// extracted by mini-css-extract-plugin
export default {"buttonStyle":"styles_buttonStyle__Lj1iE","imgWrapperStyle":"styles_imgWrapperStyle__ny3rl","imgStyle":"styles_imgStyle__X45h1"};